import { useEffect } from "react";
import { Navigate, useNavigate, useSearchParams } from "react-router-dom";
import Header from "@/components/Header";
import SignupForm from "@/components/SignupForm";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import { getValidAuthSession } from "@/lib/supabaseAuth";
import { X } from "lucide-react";

const PublicarGratis = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const selectedPlan = searchParams.get("plan") === "pro" ? "pro" : "gratis";
  const defaultUserType = searchParams.get("tipo") || "propietario";
  const nextAfterSignup =
    searchParams.get("next") ||
    (selectedPlan === "pro" ? "/registro?plan=pro&promo=primeras100" : "/registro?plan=gratis");

  useEffect(() => {
    let isMounted = true;

    getValidAuthSession().then((session) => {
      if (isMounted && session?.access_token) {
        navigate(nextAfterSignup, { replace: true });
      }
    });

    return () => {
      isMounted = false;
    };
  }, [navigate, nextAfterSignup]);

  if (selectedPlan === "gratis") {
    return <Navigate to="/registro?plan=gratis" replace />;
  }

  return (
    <>
      <Header />
      <main className="min-h-screen bg-slate-50 px-4 py-24">
        <section className="relative mx-auto max-w-md rounded-xl border border-slate-200 bg-white p-6 shadow-sm">
          <button
            type="button"
            onClick={() => navigate("/")}
            aria-label="Salir"
            className="absolute right-3 top-3 flex h-9 w-9 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-500 transition hover:bg-slate-50 hover:text-slate-900"
          >
            <X size={18} />
          </button>
          <SignupForm
            defaultUserType={defaultUserType}
            publishPlan={selectedPlan}
            publishNext={nextAfterSignup}
            onSuccess={() =>
              setTimeout(
                () =>
                  navigate(
                    `/iniciar-sesion?next=${encodeURIComponent(nextAfterSignup)}`
                  ),
                2500
              )
            }
          />
        </section>
      </main>
      <FloatingWhatsApp />
    </>
  );
};

export default PublicarGratis;
